import $ from 'jquery';
import ParamsUtil from '../../util/ParamsUtil';
import ConnectionUtil from '../../util/session/ConnectionUtil';
import PropertyUtil from '../../util/PropertyUtil';
import PreviewServerUrlGenerator from '../../util/preview/PreviewServerUrlGenerator';
import Storage from '../../protocol/Storage';
import System from '../../basic/System';
import HttpOperation from '../../protocol/HttpOperation';
import StringUtil from '../../util/StringUtil';

/**
 * PreviewAuthController is not a static type class...
 * but have some static methods which need to used in case of making authenticated sessions with preview servers.
 * Is somewhat Singleton type class, only static methods to be public.
 */
export default class PreviewAuthController {
  /**
   *
   */
  constructor() {
    /**
     *
     * @type {PreviewServerUrlGenerator}
     */
    this.urlGenerator = new PreviewServerUrlGenerator();
  }

  static logoutFromReviewServer(): void {
    const url: string = ConnectionUtil.getReviewLogoutUrl();
    $.ajax({
      contentType: false, //WC-272 Improper use of jquery ajax contentType on GET request
      crossDomain: true,
      method: 'GET',
      xhrFields: {
        withCredentials: true
      },
      url: url
    })
      .done((data, textStatus, jqXHR) => {})
      .fail((jqXHR, textStatus, errorThrown) => {});
  }

  static sendAuthRequestOnReviewServer(url: ?string) {
    if (!url) url = ConnectionUtil.getReviewAuthUrl();
    let authData = ParamsUtil.getAuthData();
    if (System.isBrowserApp()) {
      authData.thiscommandonly = true;
      authData.extclient = true;
      authData.browserurl = ConnectionUtil.getBaseUrl();
      authData.zm_web_session = Storage.get('zm_web_session');
    }
    return new Promise((resolve, onFailure) => {
      PreviewAuthController.CURRENT_AUTH_REQUEST = $.ajax({
        crossDomain: true,
        type: 'POST',
        url: url,
        data: authData,
        method: HttpOperation.POST,
        contentType: HttpOperation.REQUEST_CONTENT_TYPE
      })
        .done((data, textStatus, jqXHR) => {
          resolve([!HttpOperation.checkForAuthFailure(jqXHR.status, jqXHR), data]);
        })
        .fail((jqXHR, textStatus, errorThrown) => {
          resolve([false, errorThrown]);
        });
    });
  }

  /**
   *
   * @returns {Promise}
   */
  async createPreviewSession() {
    let authSuccessful = false;
    let previewServerUrl = this.urlGenerator.getPreviewServerUrl();
    let dataRes = undefined;
    while (!authSuccessful && PropertyUtil.checkIfNotNull(previewServerUrl)) {
      let previewServerAuthUrl = ConnectionUtil.getReviewAuthUrl(previewServerUrl);
      let [authResp, data] = await PreviewAuthController.sendAuthRequestOnReviewServer(previewServerAuthUrl);
      dataRes = data;
      if (PropertyUtil.checkIfNotNull(authResp) && authResp === true) {
        authSuccessful = true;
        PreviewServerUrlGenerator.CACHED_PREVIEW_SERVER_URL = previewServerUrl;
        break;
      } else {
        const newPreviewServerUrl = this.urlGenerator.nextPreviewServerUrl();
        if (StringUtil.isNotEmpty(newPreviewServerUrl) && previewServerUrl != newPreviewServerUrl) {
          previewServerUrl = newPreviewServerUrl;
        } else {
          previewServerUrl = null;
        }
      }
    }
    return { success: authSuccessful, data: dataRes };
  }

  /**
   *
   * @returns {*}
   */
  static async setupPreviewSessionAuth() {
    return await new PreviewAuthController().createPreviewSession();
  }

  /**
   *
   * @param previewServerUrl
   * @private
   */
  static checkPreviewSessionWithGivenPSServer(previewServerUrl) {
    return new Promise((onCallback) => {
      let checkAUthUrl = ConnectionUtil.getPreviewServerCheckAuthURL(previewServerUrl);
      checkAUthUrl = ParamsUtil.append(checkAUthUrl, { _dc: Date.now() }); //We don't want the response to be cached.
      PreviewAuthController.CURRENT_CHECK_AUTH_REQUEST = $.ajax({
        crossDomain: true,
        cache: false,
        type: 'GET',
        url: checkAUthUrl,
        xhrFields: {
          withCredentials: true
        } //,
        //contentType: HttpOperation.REQUEST_CONTENT_TYPE
      })
        .done((data, textStatus, jqXHR) => {
          //let response = { success: true, status: jqXHR && jqXHR.status ? jqXHR.status : null, data: data };
          onCallback(jqXHR.status > 0 && !HttpOperation.checkForAuthFailure(jqXHR.status, jqXHR));
        })
        .fail((jqXHR, textStatus, errorThrown) => {
          let response =
            jqXHR && jqXHR.responseText
              ? JSON.parse(jqXHR.responseText)
              : {
                  success: false,
                  message: errorThrown
                };
          onCallback(false);
        });
    });
  }

  static async checkAuthenticationAtPresentUrl(
    previewServerUrl = PreviewServerUrlGenerator.getCurrentPreviewServerUrl()
  ) {
    let sessionValid = await PreviewAuthController.checkPreviewSessionWithGivenPSServer(previewServerUrl);
    return sessionValid === true;
  }
}

/**
 *
 * @type {null}
 */
PreviewAuthController.CURRENT_CHECK_AUTH_REQUEST = null;
